import Cookie from 'js-cookie';
import { getQueryParams } from '@/utils/util';

const query = getQueryParams();

const { isLiving = false, author_id, authorId } = getQueryParams();
const ud = Cookie.get('ud') || Cookie.get('userId') || '';
const bucket = Cookie.get('bucket') || '';

const liveAuthorId = author_id || authorId;

const getLiveRoomInfo = () => {
    return {
        query,
        liveAuthorId,
        isLiving,
        ud,
        bucket,
        isAuthorSelf: +liveAuthorId === +ud,
    };
};

export default getLiveRoomInfo;

export type LiveRoomInfo = ReturnType<typeof getLiveRoomInfo>
